import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { isEmpty, isEqual } from "lodash-es";
import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { Game } from "../game/game.model";
import { GameSelector } from "../game/game.selector";
import { mapGames } from "../game/game.util";
import { GamingExternalState } from "../state";

import { ACTION_PREFIX } from "./user-games.action";

@Injectable({
	providedIn: "root",
})
export class UserGamesSelector {
	constructor(private gameSelector: GameSelector) {}

	getAllLastPlayed() {
		return (state: GamingExternalState): Game[] => {
			const gameIds = state.gamingExternal.userGames.lastPlayed;

			if (isEmpty(gameIds)) {
				return [];
			}

			return mapGames(gameIds, this.gameSelector.getAll()(state));
		};
	}

	getAllLastPlayed$() {
		return (state$: Observable<GamingExternalState>): Observable<Game[]> =>
			state$.pipe(
				distinctUntilChanged(isEqual, (state) => [
					state.gamingExternal.userGames.lastPlayed,
					this.gameSelector.getAll()(state),
				]),
				map(this.getAllLastPlayed())
			);
	}

	isBusyLastPlayed() {
		return (state: GamingExternalState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
